// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerHeaderPage {
  display: flex;
  align-items: center;
  background-color: #E0E2E5;
  min-height: 60px;
  justify-content: space-between;
  padding: 0px 35px 0px 35px;
}

.imgReturns {
  cursor: pointer;
  width: 30px;
}

.partNumber {
  padding-left: 5px;
  font-weight: 600;
  font-size: 15px;
  text-decoration: underline;
}

.textHeaderPage {
  font-weight: 500;
  font-size: 14.5px;
  color: #000000;
  margin-right: 5px;
}

.textHeader {
  font-weight: 900;
  font-size: 14.5px;
  color: #000000;
  margin-left: 5px;
}

.none {
  display: none;
}

.suggestion {
  font-weight: lighter;
}

.save-close {
  font-weight: 500;
  font-size: 15px;
  color: rgb(0, 123, 192);
  cursor: pointer;
  font-family: "Bosch Sans", sans-serif !important;
  margin-right: 40px;
}`, "",{"version":3,"sources":["webpack://./src/componentes/headerPage/headerPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;AACpB","sourcesContent":[".containerHeaderPage {\n  display: flex;\n  align-items: center;\n  background-color: #E0E2E5;\n  min-height: 60px;\n  justify-content: space-between;\n  padding: 0px 35px 0px 35px;\n}\n\n.imgReturns {\n  cursor: pointer;\n  width: 30px;\n}\n\n.partNumber {\n  padding-left: 5px;\n  font-weight: 600;\n  font-size: 15px;\n  text-decoration: underline;\n}\n\n.textHeaderPage {\n  font-weight: 500;\n  font-size: 14.5px;\n  color: #000000;\n  margin-right: 5px;\n}\n\n.textHeader {\n  font-weight: 900;\n  font-size: 14.5px;\n  color: #000000;\n  margin-left: 5px;\n}\n\n.none {\n  display: none;\n}\n\n.suggestion {\n  font-weight: lighter;\n}\n\n.save-close {\n  font-weight: 500;\n  font-size: 15px;\n  color: rgb(0, 123, 192);\n  cursor: pointer;\n  font-family: \"Bosch Sans\", sans-serif !important;\n  margin-right: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
